/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * ISingleCategoryBanner contentModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

export const enum imagePosition {
    left = 'left',
    center = 'center',
    right = 'right'
}

export const enum actionableRegion {
    imageAndLinks = 'imageAndLinks',
    linksOnly = 'linksOnly'
}

export const enum enhancedEcommTracking {
    promotion = 'promotion'
}

export interface ISingleCategoryBannerConfig extends Msdyn365.IModuleConfig {
    useSeoData?: boolean;
    useDynamicImages?: boolean;
    dynamicImages?: IDynamicImagesData;
    heading?: IHeadingData;
    paragraph?: Msdyn365.RichText;
    image?: Msdyn365.IImageData;
    links?: ILinksData[];
    imagePosition?: imagePosition;
    actionableRegion?: actionableRegion;
    imageLink?: Msdyn365.ILinkData;
    imageAriaLabel?: string;
    className?: string;
    categoryRecordId?: string;
    enhancedEcommTracking?: enhancedEcommTracking;
    tealiumEvent?: ITealiumEventData;
    tealiumPromotion?: ITealiumPromotionData;
}

export interface IDynamicImagesData {
    desktopImage?: Msdyn365.IImageData;
    tabletImage?: Msdyn365.IImageData;
    mobileImage?: Msdyn365.IImageData;
}

export const enum HeadingTag {
    h1 = 'h1',
    h2 = 'h2',
    h3 = 'h3',
    h4 = 'h4',
    h5 = 'h5',
    h6 = 'h6'
}

export interface IHeadingData {
    text: string;
    tag?: HeadingTag;
}

export interface ILinksData {
    linkText?: string;
    linkUrl: Msdyn365.ILinkData;
    ariaLabel?: string;
    openInNewTab?: boolean;
}

export interface ITealiumEventData {
    event?: string;
    event_category?: string;
    event_action?: string;
    event_label?: string;
}

export interface ITealiumPromotionData {
    promotion_name?: string;
    promotion_id?: string;
    promotion_creative_version?: string;
    promotion_position?: string;
}

export interface ISingleCategoryBannerProps<T> extends Msdyn365.IModule<T> {
    config: ISingleCategoryBannerConfig;
}
